import Axios from "axios";

export const clickTrackLog = (
  eventId,
  exhibitorId,
  clientKey,
  name,
  value,
  area,
  callback = () => null
) => {
  callback();

  if (!eventId || !clientKey || !name || !value || !area) return;

  Axios.post(`./api/link/clicktrack/`, {
    eventId,
    exhibitorId,
    clientKey,
    value,
    name,
    area,
  }).catch((err) => console.error("COULD NOT LOG CLICK"));
};
